import { Controller } from "@hotwired/stimulus"

// Closes the <details>-based mobile nav once a link inside it is chosen.
export default class extends Controller {
  close() {
    this.element.removeAttribute("open")
  }
}
